var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffb600",
    d: "M6.247 8.637zm0 0l2.288 2.328a.356.356 0 0 0 .516 0l5.304-5.41 1.21 1.232.598.61-6.47 6.591a1.267 1.267 0 0 1-.902.383c-.335 0-.663-.139-.901-.383l-3.446-3.513zM20 10.002C19.999 4.488 15.514 0 10 0 4.487 0 .002 4.488.002 10.002.002 15.514 4.487 20 10 20c5.514 0 9.999-4.486 9.999-9.998z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.c91b6be29f00116033f637658d8d80cb.svg";
export { ForwardRef as ReactComponent };